import { Box, Button, Dialog, IconButton, Stack, Typography } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SmsRoundedIcon from '@mui/icons-material/SmsRounded'
import { useTranslation } from 'react-i18next'

const WHATSAPP_GREEN = '#25D366'

const channelButtonSx = {
  width: '100%',
  minHeight: 56,
  px: 2.4,
  justifyContent: 'flex-start',
  borderRadius: '8px',
  backgroundColor: '#fff',
  color: '#071F28',
  boxShadow: 'none',
  fontSize: 17,
  fontWeight: 800,
  textTransform: 'none',
  border: '1px solid #D8DEE1',
  transition: 'transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease',
  '& .MuiButton-startIcon': { mr: 1.4, ml: 0 },
  '&:hover': { backgroundColor: '#F8FAFD' },
}

export const ChannelPickerDialog = ({ open, phoneNumber, onSelect, onClose }) => {
  const { t } = useTranslation('signup')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: '10px',
          backgroundColor: '#fff',
          boxShadow: '0 28px 80px rgba(0,0,0,0.38)',
          p: 0,
        },
      }}
      BackdropProps={{ sx: { backgroundColor: 'rgba(0,0,0,0.7)' } }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: 'absolute', top: 10, right: 10, color: '#2C3338' }}
      >
        <CloseRoundedIcon />
      </IconButton>

      <Stack spacing={2.4} sx={{ px: 3.5, pt: 4.5, pb: 3.5 }}>
        <Box>
          <Typography sx={{ color: '#071F28', fontSize: 22, fontWeight: 900, textAlign: 'center', mb: 0.5 }}>
            {t('otpChannel.title', 'How should we send your code?')}
          </Typography>
          {phoneNumber && (
            <Typography sx={{ color: '#4A5A63', fontSize: 14, textAlign: 'center' }}>
              {t('otpChannel.subtitle', 'We will send a verification code to')} <b>{phoneNumber}</b>
            </Typography>
          )}
        </Box>

        <Stack spacing={1.4}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => onSelect('whatsapp')}
            startIcon={<WhatsAppIcon sx={{ color: WHATSAPP_GREEN, fontSize: 26 }} />}
            sx={{
              ...channelButtonSx,
              '&:hover': {
                borderColor: WHATSAPP_GREEN,
                backgroundColor: 'rgba(37,211,102,0.06)',
                boxShadow: '0 10px 24px rgba(37,211,102,0.15)',
              },
            }}
          >
            {t('otpChannel.whatsapp', 'Send via WhatsApp')}
          </Button>

          <Button
            type="button"
            variant="outlined"
            onClick={() => onSelect('sms')}
            startIcon={<SmsRoundedIcon sx={{ color: '#FE1F02', fontSize: 26 }} />}
            sx={{
              ...channelButtonSx,
              '&:hover': {
                borderColor: '#FE1F02',
                backgroundColor: 'rgba(254,31,2,0.05)',
                boxShadow: '0 10px 24px rgba(254,31,2,0.12)',
              },
            }}
          >
            {t('otpChannel.sms', 'Send via SMS')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}

export default ChannelPickerDialog
